import { useEffect, useState } from 'react'

const GOOGLE_API_KEY = 'AIzaSyDnVKDee1NLC5Uo8ZmfB_6HDM8rYC0Rncs'

const URL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places`

export const useGoogleApi = () => {
  const [status, setStatus] = useState({
    loaded: false,
    error: false,
  })

  useEffect(() => {
    const scriptElement = document.querySelector(`script[src="${URL}"]`) as HTMLScriptElement

    const script = scriptElement || document.createElement('script')
    script.src = URL
    script.async = true

    const handleLoad = () => {
      setStatus({
        loaded: true,
        error: false,
      })
    }

    const handleError = () => {
      const currentScript = document.querySelector(`script[src="${URL}"]`)
      if (currentScript) {
        currentScript?.parentNode?.removeChild(currentScript)
      }

      setStatus({
        loaded: true,
        error: true,
      })
    }

    script.addEventListener('load', handleLoad)
    script.addEventListener('error', handleError)

    if (!scriptElement) {
      document.body.appendChild(script)
    } else if ((window as any).google) {
      handleLoad()
    }

    return () => {
      script.removeEventListener('load', handleLoad)
      script.removeEventListener('error', handleError)
    }
  }, [])

  return status
}
